import { cn } from "@/lib/utils";

interface PamoyaLogoProps {
  className?: string;
  /** Surcharge la taille du wordmark (défaut : h-[50%]). */
  wordmarkClassName?: string;
}

/**
 * Logo officiel Pamoya — icône « P » + wordmark (assets /public/brand).
 * Le wordmark bascule marine → blanc automatiquement en dark mode.
 */
export function PamoyaLogo({ className, wordmarkClassName }: PamoyaLogoProps) {
  const wm = wordmarkClassName ?? "ml-0 sm:ml-0.5 h-[50%]";
  return (
    <span
      className={cn("inline-flex h-8 w-auto items-center", className)}
      role="img"
      aria-label="Pamoya"
    >
      <img src="/brand/pamoya-icon.png" alt="" className="h-full w-auto" />
      <img
        src="/brand/pamoya-wordmark.png"
        alt=""
        className={cn("mt-3 w-auto dark:hidden", wm)}
      />
      <img
        src="/brand/pamoya-wordmark-white.png"
        alt=""
        className={cn("mt-3 hidden w-auto dark:block", wm)}
      />
    </span>
  );
}
